import { StoreState } from '../types';

export const getProjects = (state: StoreState) => state.projects;
